/**
 * Nature's Pantry - Custom Theme JavaScript
 * Ported from index_combined.html for pixel-perfect functionality
 */

(function() {
  'use strict';

  // ========================================
  // MOBILE MENU
  // ========================================
  const mobileMenuBtn = document.getElementById('np-mobile-menu-btn');
  const mobileMenu = document.getElementById('np-mobile-menu');

  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      // Toggle aria-expanded for accessibility
      const isExpanded = mobileMenu.classList.contains('active');
      mobileMenuBtn.setAttribute('aria-expanded', isExpanded);
    });
  }

  // Close mobile menu when clicking a link
  document.querySelectorAll('#np-mobile-menu a').forEach(function(link) {
    link.addEventListener('click', function() {
      if (mobileMenu) {
        mobileMenu.classList.remove('active');
        if (mobileMenuBtn) {
          mobileMenuBtn.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

  // ========================================
  // CAROUSEL FUNCTIONALITY
  // ========================================
  class NaturesPantryCarousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.np-carousel__track');
      this.slides = container.querySelectorAll('.np-carousel__slide');
      this.dots = container.querySelectorAll('.np-carousel__dot');
      this.prevBtn = container.querySelector('.np-carousel__btn--prev');
      this.nextBtn = container.querySelector('.np-carousel__btn--next');

      this.currentSlide = 0;
      this.totalSlides = this.slides.length;
      this.autoSlideInterval = null;
      this.autoSlideDelay = 4000;

      this.init();
    }

    init() {
      // Set up button listeners
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.move(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.move(1));
      }

      // Set up dot listeners
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Start auto-slide
      this.startAutoSlide();

      // Pause on hover
      this.container.addEventListener('mouseenter', () => this.stopAutoSlide());
      this.container.addEventListener('mouseleave', () => this.startAutoSlide());

      // Touch support
      let touchStartX = 0;
      let touchEndX = 0;

      this.container.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.container.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      }, { passive: true });
    }

    handleSwipe(startX, endX) {
      const threshold = 50;
      const diff = startX - endX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.move(1); // Swipe left, go next
        } else {
          this.move(-1); // Swipe right, go prev
        }
      }
    }

    move(direction) {
      this.currentSlide = (this.currentSlide + direction + this.totalSlides) % this.totalSlides;
      this.update();
      this.resetAutoSlide();
    }

    goToSlide(index) {
      this.currentSlide = index;
      this.update();
      this.resetAutoSlide();
    }

    update() {
      if (this.track) {
        this.track.style.transform = `translateX(-${this.currentSlide * 100}%)`;
      }

      this.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentSlide);
      });
    }

    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => this.move(1), this.autoSlideDelay);
    }

    stopAutoSlide() {
      clearInterval(this.autoSlideInterval);
    }

    resetAutoSlide() {
      this.stopAutoSlide();
      this.startAutoSlide();
    }
  }

  // Initialize all carousels on page
  document.querySelectorAll('.np-carousel').forEach(function(carousel) {
    new NaturesPantryCarousel(carousel);
  });

  // ========================================
  // CART
  // ========================================
  // The Refresh theme handles cart icon, count, and drawer natively.
  // We only need addToCart for our custom [data-quick-add] buttons.
  window.NaturesPantry = window.NaturesPantry || {};

  // ========================================
  // TOAST NOTIFICATIONS
  // ========================================
  function showToast(message) {
    const toast = document.getElementById('np-toast');
    const toastMessage = document.getElementById('np-toast-message');

    if (toast && toastMessage) {
      toastMessage.textContent = message;
      toast.classList.add('active');

      setTimeout(function() {
        toast.classList.remove('active');
      }, 3000);
    }
  }

  window.NaturesPantry.showToast = showToast;

  // ========================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ========================================
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');

      // Skip if it's just "#" or a data attribute trigger
      if (targetId === '#' || targetId.length <= 1) {
        return;
      }

      const target = document.querySelector(targetId);

      if (target) {
        e.preventDefault();

        // Close mobile menu if open
        if (mobileMenu) {
          mobileMenu.classList.remove('active');
        }

        // Smooth scroll to target
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // ========================================
  // FORM SUBMISSIONS (for custom forms)
  // ========================================

  // Newsletter form handling
  const newsletterForms = document.querySelectorAll('.np-newsletter__form');
  newsletterForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      // Let Shopify handle the form if it has the proper action
      // This is just for showing a toast message
      if (!form.getAttribute('action') || form.getAttribute('action') === '#') {
        e.preventDefault();
        showToast('Thank you for subscribing!');
        form.reset();
      }
    });
  });

  // Contact form handling
  const contactForms = document.querySelectorAll('.np-contact__form');
  contactForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      // Let Shopify handle the form if it has the proper action
      if (!form.getAttribute('action') || form.getAttribute('action') === '#') {
        e.preventDefault();
        showToast('Message sent successfully!');
        form.reset();
      }
    });
  });

  // ========================================
  // AJAX ADD TO CART
  // ========================================
  function addToCart(variantId, quantity) {
    quantity = quantity || 1;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      if (data.status === 422) {
        throw new Error(data.description || 'Could not add to cart');
      }

      // Let the Refresh theme's cart-drawer handle everything:
      // updates drawer contents, updates cart-icon-bubble, opens drawer
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && data.sections) {
        cartDrawerEl.renderContents({ id: variantId, sections: data.sections });
      }

      return data;
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      showToast('Error: ' + error.message);
      throw error;
    });
  }

  window.NaturesPantry.addToCart = addToCart;

  // ========================================
  // QUICK ADD TO CART BUTTONS
  // ========================================
  // Use event delegation so buttons rendered after initial load still work
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();

    const variantId = btn.getAttribute('data-variant-id');
    const quantity = parseInt(btn.getAttribute('data-quantity') || '1', 10);

    if (variantId) {
      btn.disabled = true;
      btn.classList.add('loading');

      addToCart(variantId, quantity)
        .finally(function() {
          btn.disabled = false;
          btn.classList.remove('loading');
        });
    }
  });

  // ========================================
  // HEADER SCROLL BEHAVIOR
  // ========================================
  let lastScrollTop = 0;
  const header = document.querySelector('.np-header');

  if (header) {
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Add shadow when scrolled
      if (scrollTop > 10) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      lastScrollTop = scrollTop;
    }, { passive: true });
  }

  // ========================================
  // INTERSECTION OBSERVER FOR ANIMATIONS
  // ========================================
  if ('IntersectionObserver' in window) {
    const animateOnScroll = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('np-animate-visible');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.np-animate-on-scroll').forEach(function(el) {
      animateOnScroll.observe(el);
    });
  }

  // ========================================
  // TESTIMONIALS HORIZONTAL SCROLL
  // ========================================
  const testimonialScrolls = document.querySelectorAll('.np-testimonials__scroll');

  testimonialScrolls.forEach(function(scroll) {
    let isDown = false;
    let startX;
    let scrollLeft;

    scroll.addEventListener('mousedown', function(e) {
      isDown = true;
      scroll.classList.add('active');
      startX = e.pageX - scroll.offsetLeft;
      scrollLeft = scroll.scrollLeft;
    });

    scroll.addEventListener('mouseleave', function() {
      isDown = false;
      scroll.classList.remove('active');
    });

    scroll.addEventListener('mouseup', function() {
      isDown = false;
      scroll.classList.remove('active');
    });

    scroll.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - scroll.offsetLeft;
      const walk = (x - startX) * 2;
      scroll.scrollLeft = scrollLeft - walk;
    });
  });

  // ========================================
  // INITIALIZE ON DOM READY
  // ========================================
  document.addEventListener('DOMContentLoaded', function() {
    // Re-initialize carousels that might have been added dynamically
    document.querySelectorAll('.np-carousel:not(.np-carousel--initialized)').forEach(function(carousel) {
      new NaturesPantryCarousel(carousel);
      carousel.classList.add('np-carousel--initialized');
    });
  });

})();
